import { useCallback, useEffect, useState } from "react";
import { useTheme } from "../../../../context/ThemeContext";
import toast from "react-hot-toast";
import Backend from "../../../../Backend/Backend";

const backend = await new Backend().init();

export default function EditBalance({
  open,
  onClose,
  user_id,
  fetchSymbol,
  item,
}) {
  const { theme } = useTheme();

  const [min_qty, setMinQty] = useState("");
  const [qty_per_order, setQtyPerOrder] = useState("");
  const [total_quantity, setTotalQty] = useState("");
  const [brokerage, setBrokerage] = useState("");
  const [margin, setMargin] = useState("");

  const [allowsymbol, setAllowSymbol] = useState(0);
  const [blocksymbol, setBlockSymbol] = useState(0);

  const [isLoading, setIsLoading] = useState(false);

  // ✅ Reset values when modal opens with a new item
  useEffect(() => {
    if (item && open) {
      setMinQty(item.min_qty ?? "");
      setQtyPerOrder(item.qty_per_order ?? "");
      setTotalQty(item.total_quantity ?? "");
      setBrokerage(item.brokerage ?? 0);
      setMargin(item.margin ?? "");
    }
  }, [item, open]);

  const handleSave = useCallback(async () => {
    setIsLoading(true);

    const payload = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      user_id: user_id,
      token: localStorage.getItem("token"),
      username: localStorage.getItem("username"),
      min :min_qty,
      order :qty_per_order,
      total : total_quantity,
      margin : margin,
      brokerage : brokerage,
      allowsymbol,
      blocksymbol,
      symbol: item.symbol_display,
      symbol_name: item.symbol_display,
      symbol_id: item.symbol_id,
      symbol_type: item.type,
    };

    try {
      const response = await backend.edit_symbol_qty(payload);
      if (response.error === "False") {
        toast.success(response.message);
        fetchSymbol();
        onClose();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("Network Error, Failed to update symbol.");
    } finally {
      setIsLoading(false);
    }
  }, [
    min_qty,
    qty_per_order,
    total_quantity,
    brokerage,
    allowsymbol,
    blocksymbol,
    margin,
    item,
    user_id,
    fetchSymbol,
    onClose,
  ]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[99999]">
      <div className="bg-white rounded-xl shadow-lg w-[90%] max-w-md p-6">
        <h2 className="text-lg font-bold text-gray-800">
          ✏️ Edit Symbol : {item.symbol_display}
        </h2>

        {/* Qty Settings */}
        <div className="grid grid-cols-2 gap-3 mt-4">
          <div>
            <label className="block text-sm font-medium">Min Qty</label>
            <input
              type="number"
              value={min_qty}
              onChange={(e) => setMinQty(e.target.value)}
              className="mt-1 w-full border rounded-lg px-2 py-1 text-sm"
            />
          </div>
          <div>
            <label className="block text-sm font-medium">Qty/Order</label>
            <input
              type="number"
              value={qty_per_order}
              onChange={(e) => setQtyPerOrder(e.target.value)}
              className="mt-1 w-full border rounded-lg px-2 py-1 text-sm"
            />
          </div>
          <div>
            <label className="block text-sm font-medium">Total Qty</label>
            <input
              type="number"
              value={total_quantity}
              onChange={(e) => setTotalQty(e.target.value)}
              className="mt-1 w-full border rounded-lg px-2 py-1 text-sm"
            />
          </div>
          <div>
            <label className="block text-sm font-medium">Brokerage</label>
            <input
              type="number"
              value={brokerage}
              onChange={(e) => setBrokerage(e.target.value)}
              className="mt-1 w-full border rounded-lg px-2 py-1 text-sm"
            />
          </div>
          <div>
            <label className="block text-sm font-medium">Margin</label>
            <input
              type="number"
              value={margin}
              onChange={(e) => setMargin(e.target.value)}
              className="mt-1 w-full border rounded-lg px-2 py-1 text-sm"
            />
          </div>
        </div>

        {/* Symbol Control */}
        <div className="flex gap-3 mt-5">
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={allowsymbol === 1}
              onChange={(e) => setAllowSymbol(e.target.checked ? 1 : 0)}
            />
            Allow
          </label>
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={blocksymbol === 1}
              onChange={(e) => setBlockSymbol(e.target.checked ? 1 : 0)}
            />
            Block
          </label>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg text-sm font-semibold bg-gray-200 hover:bg-gray-300 transition"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={isLoading}
            className="px-4 py-2 rounded-lg text-sm font-semibold text-white transition"
            style={{
              backgroundColor: theme.primary,
              opacity: isLoading ? 0.6 : 1,
            }}
          >
            {isLoading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}
